import { NotificationTemplateType } from './notification-template-type.enum';
var NotificationTemplateBuilder = /** @class */ (function () {
    function NotificationTemplateBuilder() {
        this.notification = {
            webContent: 'Hi Bob',
            emailSubject: 'nice email subject',
            emailHtml: '<p>email html</p>',
            type: NotificationTemplateType.BUG_FIXED,
            lang: 'en'
        };
    }
    NotificationTemplateBuilder.prototype.withEmailSubject = function (val) {
        this.notification.emailSubject = val;
        return this;
    };
    NotificationTemplateBuilder.prototype.withEmailHtml = function (html) {
        this.notification.emailHtml = html;
        return this;
    };
    NotificationTemplateBuilder.prototype.withWebContent = function (val) {
        this.notification.webContent = val;
        return this;
    };
    NotificationTemplateBuilder.prototype.withNotificationTemplateType = function (type) {
        this.notification.type = type;
        return this;
    };
    NotificationTemplateBuilder.prototype.withLang = function (lang) {
        this.notification.lang = lang;
        return this;
    };
    NotificationTemplateBuilder.prototype.build = function () {
        return this.notification;
    };
    return NotificationTemplateBuilder;
}());
export { NotificationTemplateBuilder };
//# sourceMappingURL=notification-template-builder.js.map